import { cwslapi } from '../index'


// 宠物深林注册
export const getregister = (data) => {
    return cwslapi({
      url: '/register/doReg',
      method: 'post',
      data
    })
  }

// 未登录状态下获取手机验证码

export const getregisterSendMsg = (data) => {
    return cwslapi({
      url: '/sms/sendMsg',
      method: 'post',
      data
    })
  }